import React, { useEffect, useMemo, useState } from "react";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import { Link, useLocation } from "react-router-dom";
import Dashboard from "../../../../Components/Icons/Dasboard";
import { useFormik } from "formik";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import * as yup from "yup";
import {
  NuDate,
  NuInput,
  NuMobileNumber,
  NuSelect,
  NuTextArea,
} from "../../../../Components/Utils/Input";
import FormikSelectTwo, { FormikAsyncSelect } from "../../../../Components/Utils/Select";
import axiosInstance from "../../../../Services/axiosCommon";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import { useToast } from "../../../../Components/Others/ToastServices";
import Attachement from "../../../../Components/Utils/CustomAttrachmentupload";
const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];
function CreateInvoiceOutgoing() {
  const location = useLocation();
  // const [loading, setLoading] = useState(false);

  const currentDate = new Date().toISOString().split('T')[0];
  const { value: Tax, getData: refTax } = useFetchMataData(`/dropdown/dropdown-details/`, 'Tax_invoicesIncoming')
  const { value: ModeOfPayment, getData: refModeOfPayment } = useFetchMataData(`/dropdown/dropdown-details/`, 'ModeOfPayment_invoicesIncoming')
  const { value: Division, getData: refDivision } = useFetchMataData(`/dropdown/dropdown-details/`, 'Division_invoicesIncoming')

  const { data: CO } = UseDropDown('/customer-orders/drop-down');
  const { data: SO } = UseDropDown('/sales-order/drop-down');
  const toast = useToast();

  const [image, setImage] = useState([]);
  // const [division, setDivision] = useState([]);
  const [customerName, setCusName] = useState(null);
  const [customerEmail, setCusEmail] = useState(null);
  const { Oncancel, addFormData, contextHolder, isLoading } = useAddFormData();
  const { data: customer } = UseDropDown("/customers/drop-down");
  const [soTotal, setSoTotal] = useState([]);
  const [createNew, setCreateNew] = useState({
    date: currentDate || "",
    amount: "",
    tax: "",
    totalAmount: "",
    modeOfPayment: "",
    paymentDueDate: currentDate || "",
    paymentReceivedOn: currentDate || "",
    comments: "",
    customerId: "",
    // "status": "Pendding",
    division: "",
    ref: "",
    coId: "",
    taxAmount: "",
    bankCharges: ""
  });
  const [selectedFile, setSelectedFile] = useState(null);

  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];
    files.map((item) => {
      if (item.size < maxFileSize) {
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size to big`,
          description: `${item.name} is Removed and not Uploaded`,
          // placement: "bottomRight",
        });
      }
    });
    let tempArr = [];
    setSelectedFile(fileArr);
    files.map((item) => {
      if (item.size < maxFileSize) {
        let fileName = item?.name;
        console.log("fname", fileName);
        let fileExtention = fileName.split(".").reverse()[0];
        if (filetype?.includes(fileExtention)) {
          tempArr.push(fileName);
        } else {
          let x = URL.createObjectURL(item);
          tempArr.push(x);
        }
      }
    });
    console.log(tempArr, "temp");
    setImage(tempArr);
  }

  const removeImages = (value) => {
    console.log("value", value);
    let List = selectedFile.filter((item) => item?.name !== value);
    console.log("LIst", List);
    setSelectedFile([...List]);
    let tempArr = [];
    List.map((item) => {
      let fileName = item?.name;
      // console.log('fname',fileName);
      // let fileExtention =  fileName.split(".").reverse()[0]
      // if(filetype?.includes(fileExtention)){
      tempArr.push(fileName);
      // }else{
      //   let x = URL.createObjectURL(item)
      //   tempArr.push(x)
      // }
    });
    setImage(tempArr);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      prId: yup.string().required('YPR is required!'),

      coId: yup.string().required('Sales Order is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      // setLoading(true); 
      let formData = new FormData();
      const valueWithItems = {
        ...value,

      };
      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
      addFormData("/invoices-outgoing/new-invoice", formData, resetForm);
      // setLoading(false)
    },
  });

  useMemo(() => {
    if (formik.values.tax != 0 || formik.values.tax != "") {
      let finalAmount = (formik.values.amount / 100) * formik.values.tax;
      formik.values.totalAmount = formik.values.amount + finalAmount;
    } else {
      formik.values.totalAmount = formik.values.amount;
    }
  }, [formik.values.amount, formik.values.tax]);

  const [Colist, setColist] = useState([]);
  // console.log("bnmbnm",Colist);


  const getPo = (coId) => {
    if (coId !== "") {
      axiosInstance
        .get(`/sales-order/${coId}`)
        .then(res => {
          console.log("nbnb", res?.data?.data?.products);
          let data = res?.data?.data?.products;
          let name = res.data?.data?.customerName;
          let email = res.data?.data?.customerEmail;
          let total = res?.data?.data?.subTotal.toFixed(2)
          setColist(data);
          name && setCusName(name);
          email && setCusEmail(email);
          total && formik.setFieldValue('amount', total)
          formik.setFieldValue('customerId', res.data?.data?.customerId)
          formik.setFieldValue('totalAmount', total)
        })
        .catch(err => {
          console.log(err, "err");
        });
    }
  };

  useEffect(() => {
    if (formik.values.coId) {
      getPo(formik.values.coId);
    }
  }, [formik.values.coId]);

  useEffect(() => {
    const amount = parseFloat(formik.values.amount || 0);
    const tax = parseFloat(formik.values.tax || 0);

    const taxAmount = ((amount) * tax / 100);

    formik.setFieldValue("taxAmount", taxAmount.toFixed(2));
    formik.setFieldValue("totalAmount", (amount + taxAmount).toFixed(2));
  }, [formik.values.amount, formik.values.tax]);


  return (
    <div className="w-full h-full py-2 px-4">
      <div className="w-full flex flex-row justify-between items-center gap-2 mb-3">
        <Breadcrumb
          items={[
            {
              name: "Invoice-Outgoing",
              link: "/sales/invoice_outgoing",
            },
            {
              name: "create",
            },
          ]}
        />
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto min-h-[calc(100vh-145px)] h-auto md:h-[calc(100vh-145px)] bg-white rounded-md overflow-hidden mt-4">
          <div className="w-full h-full py-4 px-3 flex justify-start content-start flex-wrap overflow-y-auto">
            <FormikAsyncSelect
              label="YPR"
              placeholder="YPR"
              url="/PR/drop-down"
              formik={formik}
              name="prId"
              width="w-full md:w-1/2 lg:w-1/3"
              isRequired={true}
              disabled={!!location.state}
              initialLabel={""}
            />
            <FormikSelectTwo
              type="text"
              label="Sales Order"
              placeholder="Sales Order"
              Options={SO}
              formik={formik}
              name="coId"
              width="w-full md:w-1/2 lg:w-1/3"
              isRequired={true}
            />

            {/* <FormikSelectTwo
              type="text"
              label="Customer"
              placeholder="Customer"
              Options={customer}
              formik={formik}
              name="customerId"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            {/* <NuInput
              type="number"
              label="Invoice Reference"
              placeholder="Invoice Reference"
              formik={formik}
              name="ref"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            <NuDate
              label="Invoice Date"
              placeholder="Invoice Date"
              formik={formik}
              name="date"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            {/* <NuDate
              label="Received Date"
              placeholder=" Received Date"
              formik={formik}
              name="date"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            <NuInput
              type="number"
              label="Bank Charges"
              placeholder="Bank Charges"
              formik={formik}
              name="bankCharges"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            <NuInput
              // value={soTotal}
              type="number"
              label="Amount"
              placeholder=" Amount"
              formik={formik}
              name="amount"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            <DropDownAddMetaData
              label="Tax (%)"
              placeholder="Choose"
              Options={Tax}
              formik={formik}
              name="tax"
              width="w-full md:w-1/2 lg:w-1/3"
              getFunc={refTax}
              displayProperty={"Tax (%)"}
              propertyName={"Tax_invoicesIncoming"}
            />
            <NuInput
              type="text"
              label="Tax Amount"
              placeholder="Tax Amount"
              formik={formik}
              name="taxAmount"
              width="w-full md:w-1/2 lg:w-1/3"
              disabled={true}
            />
            <NuInput
              type="number"
              label="Total Amount"
              placeholder="Total Amount"
              formik={formik}
              name="totalAmount"
              width="w-full md:w-1/2 lg:w-1/3"
              disabled={true}
            />


            <NuDate
              label="Payment DueDate"
              placeholder="Payment DueDate"
              formik={formik}
              name="paymentDueDate"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            <NuDate
              label="Payment ReceivedOn"
              placeholder="Payment ReceivedOn"
              formik={formik}
              name="paymentReceivedOn"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            <DropDownAddMetaData
              label="Mode Of Payment"
              placeholder="Choose"
              Options={ModeOfPayment}
              formik={formik}
              name="modeOfPayment"
              width="w-full md:w-1/2 lg:w-1/3"
              getFunc={refModeOfPayment}
              displayProperty={"Mode Of Payment"}
              propertyName={"ModeOfPayment_invoicesIncoming"}
            />

            {/* <DropDownAddMetaData
                label="Division"
                placeholder="Choose"
                Options={Division}
                formik={formik}
                name="division"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refDivision}
                displayProperty={"Division"}
                propertyName={"Division_invoices"}
              />
             */}

            <NuTextArea
              label="comments"
              placeholder="comments"
              formik={formik}
              name="comments"
              new_width="w-full md:w-2/3"

              width="w-full md:w-1/2 lg:w-1/3"
            />
            <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                Invoice Outgoing Attachement :
              </p>
            </div>
            <Attachement
              handleChange={handleImageChange}
              preview={image || ""}
              width="w-full"
              label="Attach"
              multiple={true}
              removeImages={removeImages}
            />

            <div className="w-full flex flex-col md:flex-row flex-wrap px-2 sm:px-4">
              {formik.values.coId && (
                <>
                  <div className="w-full md:w-1/2 lg:w-1/3 flex items-center py-2 sm:py-3 px-2 sm:px-4">
                    <p className="w-1/2 text-xs font-medium text-[#111537]">
                      Customer Name
                    </p>
                    <p className="w-1/2 pl-2 text-xs text-[#606279]">
                      {customerName}
                    </p>
                  </div>
                  <div className="w-full md:w-1/2 lg:w-1/3 flex items-center py-2 sm:py-3 px-2 sm:px-4">
                    <p className="w-1/2 text-xs font-medium text-[#111537]">
                      Customer Email
                    </p>
                    <p className="w-1/2 pl-2 text-xs text-[#606279] truncate">
                      {customerEmail}
                    </p>
                  </div>
                </>
              )}
            </div>
            {/* <div className="w-full h-0.5 opacity-30 bg-[#C4C2C2] my-6 mx-auto"></div>
            <div className="w-full bg-white overflow-y-scroll mt-5">
              <div className="w-full py-3 bg-[#048178] flex justify-between rounded-lg px-2">
              <p className="w-[5%]  text-left  text-white text-xs font-medium">S.N. </p>

                <p className="w-[50%] text-left text-white text-xs font-medium">Product</p>
                <p className="w-[10%] text-center text-white text-xs font-medium">Unit</p>
                <p className="w-[15%] text-center text-white text-xs font-medium"> Quantity</p>
                <p className="w-[15%] text-center text-white text-xs font-medium">Price</p>
                <p className="w-[15%] text-center text-white text-xs font-medium">Total</p>
              
              </div>
              {Colist?.length>0?
              <div className="h-[calc(100vh-300px)] overflow-y-scroll">

              {Colist.map((List, index) => (
                <div key={index} className="w-full py-2 flex justify-between px-2 odd:bg-white even:bg-slate-50">
                  <p className="w-[5%]  text-left  text-[#606279] text-xs font-light py-1">
                                    {index + 1}
                                </p>
                  <p className="w-[50%] text-left text-[#606279] text-xs font-light">{List?.product_name}</p>
                  <p className="w-[10%] text-center text-[#606279] text-xs font-light">{List?.unit}</p>
                  <p className="w-[15%] text-center text-[#606279] text-xs font-light">{List?.quantity}</p>
                  <p className="w-[15%] text-center text-[#606279] text-xs font-light">{List?.price}</p>
                  <p className=" w-[15%] text-center text-[#606279] text-xs font-light">
                  {(List.price * List.quantity ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} 
                  
                  </p>
                </div>
              ))}
            </div>:<div className="w-full text-center text-[#93949f]">No Items here</div>}

            </div> */}

            <div className="w-full mx-auto my-4 mt-8 px-2">
              <div className="flex justify-end gap-3 sm:gap-4">
                <CancelButton
                  handleClick={() => {
                    Oncancel(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default CreateInvoiceOutgoing;
